import { ImageComponent } from '@/components/Image';
import { CARDS_DATA } from './helpers';

import { ScCards, ScImageWrapper } from './styled';

export const Cards = () => (
  <ScCards>
    {CARDS_DATA.map(({ src, alt, width }, idx) => (
      <ScImageWrapper key={idx} width={width}>
        <ImageComponent
          alt={alt}
          className="cards-img"
          height={40}
          src={src}
          width={width}
        />
      </ScImageWrapper>
    ))}
  </ScCards>
);
